<template>
  <div class="settle_info">
    
    <!-- 검색 조건 영역 Start -->
    <div class="search_info">
      <dl class="search_title">
        <dt>상담 일자</dt>
        <dd>
          <div class="btn_group">
            <ul class="btn_radio">
              <li>
                <input type="radio" name="search_date_type" id="apply" value="1" v-model="search_date_type">
                <label for="apply" class="search_radio">상담 신청일자</label>
              </li>
              <li>
                <input type="radio" name="search_date_type" id="complete" value="2" v-model="search_date_type">
                <label for="complete" class="search_radio">상담 완료일자</label>
              </li>
            </ul>
          </div>
        </dd>
      </dl>
      <dl class="search_title">
        <dt>상담 상태</dt>
        <dd>
          <div>
            <input type="checkbox" name="search_consult_status_all" id="search_consult_status_all" value="0" v-model="search_consult_status_all" @click="search_consult_status_check_all()">
            <label for="search_consult_status_all">전체&nbsp;&nbsp;&nbsp;</label>
            
            <input type="checkbox" name="search_consult_status_1" id="search_consult_status_1" value="1" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_1">신청&nbsp;&nbsp;&nbsp;</label>
            
            <input type="checkbox" name="search_consult_status_2" id="search_consult_status_2" value="2" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_2">접수완료&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="search_consult_status_3" id="search_consult_status_3" value="3" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_3">청구서입력&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="search_consult_status_4" id="search_consult_status_4" value="4" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_4">수납대기&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="search_consult_status_5" id="search_consult_status_5" value="5" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_5">상담완료&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="search_consult_status_9" id="search_consult_status_9" value="9" v-model="search_consult_status" @click="search_consult_status_check()">
            <label for="search_consult_status_9">상담취소&nbsp;&nbsp;&nbsp;</label>
          </div>
        </dd>
      </dl>
      <dl class="search_title">
        <dt>정산 상태</dt>
        <dd>
          <div>
            <input type="checkbox" id="settled-all" value="2" v-model="search_settled_all" @click="search_settled_check_all()">
            <label for="settled-all">전체&nbsp;&nbsp;&nbsp;</label>
            
            <input type="checkbox" id="settled-complete" value="1" v-model="search_settled" @click="search_settled_check()">
            <label for="settled-complete">정산완료&nbsp;&nbsp;&nbsp;</label>
            
            <input type="checkbox" id="settled-not-complete" value="0" v-model="search_settled" @click="search_settled_check()">
            <label for="settled-not-complete">미정산&nbsp;&nbsp;&nbsp;</label>
          </div>
        </dd>
      </dl>

      <dl class="search-title">
        <dt>상담 구분</dt>
        <dd>
          <div>
            <input type="checkbox" name="settle-type-all" id="settle-type-all" value="0" v-model="search_what_is_all" @click="search_what_is_check_all()">
            <label for="settle-type-all">전체&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="settle-type-immediately" id="settle-type-immediately" value="1" v-model="search_what_is" @click="search_what_is_check()">
            <label for="settle-type-immediately">즉시상담&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="settle-type-reservation" id="settle-type-reservation" value="2" v-model="search_what_is" @click="search_what_is_check()">
            <label for="settle-type-reservation">예약상담&nbsp;&nbsp;&nbsp;</label>

            <input type="checkbox" name="settle-type-message" id="settle-type-message" value="3" v-model="search_what_is" @click="search_what_is_check()">
            <label for="settle-type-message">쪽지상담&nbsp;&nbsp;&nbsp;</label>
          </div>
        </dd>
      </dl>

      <dl class="search_title">
        <dt>검색 기간</dt>
        <dd>
          <div class="inpt">
              <input type="date" name="search_start_date" id="search_start_date" v-model="search_start_date" :formatter="dateFormatter">
              <span> ~ </span>
              <input type="date" name="search_end_date" id="search_end_date" v-model="search_end_date" :formatter="dateFormatter">
          </div>

          <div v-show="false" class="clearfix">
            <v-range-selector style="width:736px;" :search_start_date.sync="search_start_date" :search_end_date.sync="search_end_date"  />
          </div>
        </dd>
      </dl>     
      <dl class="search_title">
        <dt>검색조건</dt>
        <dd>
          <select name="search_type" id="search_type" class="search_type" v-model="search_type">
            <!-- <option value="1">전체</option> -->
            <option value="2">상담자</option>
            <!-- <option value="3">결제자</option> -->
          </select>
          <input type="text" name="search_name" id="search_name" class="search_name" placeholder="이름 검색" v-model="search_name">
          <button class="btn_submit_left" @click="search()">검색</button>
          
          <!-- 
          <div class="summary_area">
            Total: 9 건 / 금액: 55,000 원 / 완료: 10 건 / 신청: 1 건 / 취소: 1 건
          </div> 
          -->
        </dd>
      </dl>
    </div>
    <!-- 검색 조건 영역 End -->
      
    
    

    <div class="button_area">
      <!-- 
      <select name="page_select" id="page_select" class="page_select" @change="onChange($event)">
        <option>페이지당 50개</option>
        <option>페이지당 100개</option>
      </select> 
      -->

      <button class="btn_submit_right" @click="downloadExcel()">엑셀 다운로드</button>
    </div>
    <!-- 버튼 영역 End -->
 
    <!-- List 영역 Start -->
    <div class="table_list">
      <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="정산 상세 목록" class="settle_bottom_list">
        <caption style="display: none;">정산 상세 목록</caption>
        <colgroup>
          <col width="2%">
          <col width="10%">
          <col width="10%">
          <col width="*%">
          <col width="10%">
          <col width="10%">
          <col width="10%">
          <col width="10%">
          <col width="10%">
          <col width="10%">
        </colgroup>
        <thead>
        <tr>
          <th><input type="checkbox" v-model="selectAll"></th>
          <th>상담신청일</th>
          <th>상담완료일</th>
          <th>병원/의사</th>
          <th>상담자</th>
          <th>상담료</th>
          <th>상담구분</th>
          <th>정산금액</th>
          <th>상담상태</th>
          <th>정산상태</th>
        </tr>
        </thead>
        <tbody>
          <!-- <tr v-for="(settlement, index) in bottom_settlements" @click="chosen_row(settlement, index)" :key="settlement.consult_id"> -->
          <tr v-for="(settlement, index) in bottom_settlements" :key="settlement.consult_id">
            <td><input type="checkbox" v-model="excel_checked" :value="settlement.consult_id"></td>
            <td>{{ settlement.request_at | date_split_format }}</td>
            <td>{{ settlement.finished_at | date_split_format }}</td>
            <td>{{ settlement.dr_name }}</td>
            <td>{{ settlement.request_user }}</td>
            <td>{{ settlement.consult_fee | price_format }}</td>
            <td>{{ settlement.what_is}}</td>
            <td>{{ settlement.system_fee | price_format }}</td>
            <td>{{ settlement.consult_status }}</td>
            <td>{{ settlement.settled }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- List 영역 End -->
    

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import VRangeSelector from 'vuelendar/components/vl-range-selector.vue';
  import moment from 'moment-timezone'
  import XLSX from 'xlsx'

  export default {
    name: 'settle-bottom-tel-list',
    props: ['bottom_settlements', 'searchParams'],
    data () {
      return {
        search_date_type: '1', //상담일자 radio
        
        //상담상태 checkbox
        search_consult_status_all: true,
        search_consult_status: [],        
        
        //정산상태 checkbox
        search_settled_all: true,
        search_settled: [],

        //상담구분 checkbox
        search_what_is_all: true,
        search_what_is: [],        
        
        search_start_date: this.searchParams.date_start,
        search_end_date: this.searchParams.date_end,
        search_type: '2', //검색조건 select
        search_name: '', //이름검색 text

        excel_checked: [],
      }
    },
    computed: {
        ...mapState(['account']),
        selectAll: {
          get: function () {
            return this.bottom_settlements ? this.excel_checked.length == this.bottom_settlements.length : false;
          },
          set: function (value) {
            var excel_checked = [];

            if (value) {
              this.bottom_settlements.forEach(function (settlement) {
                excel_checked.push(settlement.consult_id);
              });
            }

            this.excel_checked = excel_checked;
          }
        }
    },
    methods: {
      dateFormatter(value, event) {
        if(value){
          return moment(value).format('YYYY-MM-DD');
        }else{
          return '';
        }
      },
      search(){
        let date_start = '';
        let date_end = '';
        if(this.search_start_date){
          date_start = moment(this.search_start_date).format('YYYY-MM-DD HH:mm:ss');
        }        
        if(this.search_end_date){
          date_end = this.search_end_date + ' 23:59:59';
        }

        let searchParams = {
          //'consult_type': 1, //1. 전화처방, 2. 나머지 this.settle_type
          'date_type': this.search_date_type, //search_date_type 상담일자 Radio
          'consult_status': this.search_consult_status, //search-consult-status-~ 상담상태 Checkbox
          'settled': this.search_settled, //search-settled 정산상태 Radio
          // 'date_start': this.search_start_date, //search-start-date 검색기간 Text 시작일
          // 'date_end': this.search_end_date, //search-end-date 검색기간 Text 종료일
          'date_start': date_start, //search-start-date 검색기간 Text 시작일
          'date_end': date_end, //search-end-date 검색기간 Text 종료일
          'search_type': this.search_type, //search_type 검색조건 Select
          'search': this.search_name, //search_name 이름 Text
          'what_is': this.search_what_is //상담구분 checkbox
        }
        this.$emit('searchEvent', searchParams);
      },

      //상담상태 checkbox 컨트롤
      search_consult_status_check_all(){
        this.search_consult_status = [];
        if (this.search_consult_status_all) {
          for (status in this.search_consult_status) {
            this.search_consult_status.push(this.search_consult_status[status].value.toString());
          }
        }
      },
      search_consult_status_check(){
        this.search_consult_status_all = false;
      },

      //정산상태 checkbox 컨트롤
      search_settled_check_all(){
        this.search_settled = [];
        if (this.search_settled_all) {
          for (settled in this.search_settled) {
            this.search_settled.push(this.search_settled[settled].value.toString());
          }
        }
      },
      search_settled_check(){
        this.search_settled_all = false;
      },

      //상담구분 checkbox 컨트롤
      search_what_is_check_all(){
        this.search_what_is = [];
        if (this.search_what_is_all) {
          for (what in this.search_what_is) {
            this.search_what_is.push(this.search_what_is[what].value.toString());
          }
        }
      },
      search_what_is_check(){
        this.search_what_is_all = false;
      },

      //엑셀 다운로드
      downloadExcel(){
        if(this.excel_checked.length > 0){
          let settleWs = new Array();

          for(let i=0; i<this.excel_checked.length; i++){
            for(let j=0; j<this.bottom_settlements.length; j++){
              if(this.excel_checked[i] == this.bottom_settlements[j].consult_id){
                let jsonVal = this.bottom_settlements[i];

                //영문key를 한글key로 추가 해준다
                jsonVal.상담신청일 = jsonVal.request_at ? jsonVal.request_at : '';
                jsonVal.상담완료일 = jsonVal.finished_at ? jsonVal.finished_at : '';
                jsonVal.병원의사 = jsonVal.dr_name ? jsonVal.dr_name : '';
                jsonVal.상담자 = jsonVal.request_user ? jsonVal.request_user : '';
                jsonVal.상담료 = jsonVal.consult_fee ? jsonVal.consult_fee : '';
                jsonVal.상담구분 = jsonVal.what_is ? jsonVal.what_is : 0;
                jsonVal.정산금액 = jsonVal.system_fee ? jsonVal.system_fee : 0;
                jsonVal.상담상태 = jsonVal.consult_status ? jsonVal.consult_status : '';
                jsonVal.정산상태 = jsonVal.settled ? jsonVal.settled : '';
                
                //안보여줄 항목 삭제
                // delete jsonVal.dr_id;
                // delete jsonVal.consult_id;
                
                //한글 key로 새로 넣었으므로 영문key는 삭제
                // delete jsonVal.request_at;
                // delete jsonVal.finished_at;
                // delete jsonVal.dr_name;
                // delete jsonVal.request_user;
                // delete jsonVal.consult_fee;
                // delete jsonVal.what_is;
                // delete jsonVal.system_fee;
                // delete jsonVal.consult_status;
                // delete jsonVal.settled;

                //위에꺼로하면 버그있음 데이터가 날아감 ... -> 생각해보니 value가 아닌 refernce 복사가 되어서 같이 삭제 되는듯
                let jsonVal2 = new Object();
                jsonVal2.상담신청일 = jsonVal.request_at ? jsonVal.request_at.split(' ')[0] : '';
                jsonVal2.상담완료일 = jsonVal.finished_at ? jsonVal.finished_at.split(' ')[0] : '';
                jsonVal2.병원의사 = jsonVal.dr_name ? jsonVal.dr_name : '';
                jsonVal2.상담자 = jsonVal.request_user ? jsonVal.request_user : '';
                jsonVal2.상담료 = jsonVal.consult_fee ? jsonVal.consult_fee : '';
                jsonVal2.상담구분 = jsonVal.what_is ? jsonVal.what_is : 0;
                jsonVal2.정산금액 = jsonVal.system_fee ? jsonVal.system_fee : 0;
                jsonVal2.상담상태 = jsonVal.consult_status ? jsonVal.consult_status : '';
                jsonVal2.정산상태 = jsonVal.settled ? jsonVal.settled : '';

                settleWs[i] = jsonVal2;
              }
            }
          }

          //const settleWS = XLSX.utils.json_to_sheet(this.bottom_settlements)
          const sheetData = XLSX.utils.json_to_sheet(settleWs)
          var wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, sheetData, '정산 목록')
          XLSX.writeFile(wb, '건강상담정산.xlsx')
        }else{
          alert('다운로드 받으실 데이터를 체크해 주세요.');
          return false;
        }
      }
    },
    async mounted () {
      // console.log('eventinfo 마운트됨!')
      // console.log(this.searchParams.date_start)
      // console.log(this.searchParams)
    },
    watch: {
      //  seq: function (seq) {
      //    console.log('seq 변경됨(watch)', seq)
      //    this.event_img = this.settlement.event_img; //배너이미지 처리
      //  },
    },
    components: {
      VRangeSelector
    }
    
  }
</script>

<style scoped>
    .settle_info > div {
        margin-bottom: 15px;
    }

    .settle_info h3 {
        color: #4c4c4c;
        margin-bottom: 20px;
        letter-spacing: -.5px;
        font: 500 16px 'Noto Sans KR', sans-serif;
    }    

    .search_info{
        margin-bottom:30px;
    }

    .search_info dl{
      color: #000000;
      margin-bottom: 10px;
      height: 20px;
      font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .search_info dt,
    .search_info dd{
      font:400 13px Noto Sans KR,sans-serif;
      min-height:20px;
      margin-bottom:10px;
    }

    .search_info dt{
      float:left;
      width:70px;
      margin-right:10px;
      color:#000000;
    }

    .search_info dd{
      color:#484848;
    }


    .summary_area {
      float: right;
    }

    /* .summary_area p{
      margin-bottom: 15px;
    } */

    .button_area {
      border-top: 1px solid #e7e7e9;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    
    .button_area .page_select {
        width: 110px;
        padding: 3px 5px;
        float:left;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 98% no-repeat;
    }

    .btn_submit_right{
      width:100px;
      height:30px;
      line-height:32px;
      padding:0;
      /* margin:0 10px 10px 0; */
      border:0;
      background:#5e71e9;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
      float:right;
      font:400 12px Noto Sans KR,sans-serif;
    }

    .btn_submit_left {
      width:50px;
      height:26px;
      background:#5e71e9;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
      float:left;
      margin-left: 10px;
      font:400 13px Noto Sans KR,sans-serif;
    }

    .btn_group {
        /* overflow:hidden; */
        margin-bottom: 15px;
    }

    .btn_group .btn_radio {
        text-align:left;
        font-size: 0;
        margin-top: 5px;
    }

    .btn_group .btn_radio > li {
        color: #000000;
        margin-left: 3px;
        display: inline-block;
    }

    .search_radio {
        display: block;
        text-indent: 17px;
        cursor: pointer;
        position: relative;
        font: 400 12px 'Noto Sans KR', sans-serif;
        margin-right: 10px;
    }

    .search_radio::before {
        content: '';
        display: block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid rgb(150, 135, 135);
        box-sizing: border-box;
        background-color: #fff;
        position: absolute;
        left: 0;
        top: 2px;
    }

    .btn_group .btn_radio input[type="radio"] {
        display: none;
    }

    .btn_group .btn_radio input[type="radio"]:checked + .search_radio::before {
        border: 3px solid #3a30ff;
    }

    .search_type {
        width: 142px;
        padding: 3px 5px;
        float:left;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 98% no-repeat;
        margin-bottom: 20px;
    }

    .search_name {
        float: left;
        width: 200px;
        height: 25px;
        margin-left: 12px;
        padding: 0 5px;
        box-sizing: border-box;
        border: 1px solid #000000;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }


    

    .settle_bottom_list{
      background-color: #fff;
    }

    .settle_bottom_list thead {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e7e7e9;
        border-top: 1px solid #e7e7e9;
    }

    .settle_bottom_list thead th {
        color: #b8b8b8;
        font: 500 12px/40px 'Noto Sans KR', sans-serif;
    }

    .settle_bottom_list tbody tr {
        /* height: 70px; */
        height: 40px;
        background-color: #fff;
        cursor: pointer;
        border-bottom: 1px solid #e7e7e9;
    }

    .settle_bottom_list tbody tr:hover,
    .settle_bottom_list tbody tr.on {
        background-color: #f5f6fa;
    }

    .settle_bottom_list tbody td {
        text-align: center;
        vertical-align: middle;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .settle_bottom_list tbody td .user-name {
        float: left;
        overflow: hidden;
        width: 120px;
        height: 40px;
        line-height: 40px;
        margin-right: 15px;
        padding-left: 10px;
    }

    .settle_bottom_list tbody td .event-name {
        float: left;
        text-align: left;
    }
</style>
